<template>
	<div>
		<o-alert
			v-if="setup.errorMessage"
			color="warning">
			{{ setup.errorMessage }}
		</o-alert>
		<iframe
			v-else
			:ref="setup._iframe"
			scrolling="yes"
			frameborder="0"
			:style="[{ width: '100%' }, { height: setup.heightIframe }]"
			:src="procedure"/>
	</div>
</template>

<script setup lang="ts">
import ModalOtpSetupService from '@/setup/modal/ModalOtpSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(ModalOtpSetupService.props);
const setup = new ModalOtpSetupService(props, _modal);
</script>
